import { InputProps } from '@nextui-org/react';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Input } from '@/components';

interface IRHFInputProps extends InputProps {
  name: string;
  onChange?: (_event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const RHFInput: React.FC<IRHFInputProps> = ({ name, defaultValue, onChange, ...props }) => {
  const { control } = useFormContext<Record<string, string>>();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue as string}
      render={({ field: { value, onChange: onFieldChange }, fieldState: { error } }) => (
        <Input
          id={name}
          name={name}
          value={value || ''}
          onChange={(e) => {
            onFieldChange(e);
            onChange?.(e);
          }}
          isInvalid={!!error}
          errorMessage={error?.message}
          {...props}
        />
      )}
    />
  );
};

export default RHFInput;
